module.exports = __webpack_public_path__ + "static/media/DSCF0226-b5voiYgs.77fd3624.JPG";